import { auth } from '../config/firebaseConfig';
import { API_BASE_URL } from '../config/apiConfig';


const getAuthToken = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error('No authenticated user found.');
  return await currentUser.getIdToken();
};

export const engineService = {
  /**
   * 채팅방 기반 엔진 세션 초기화
   * POST /api/engine/init-room
   */
  async initRoomSession(roomId, initialMessage = '') {
    const token = await getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/engine/init-room`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ roomId, initialMessage }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errData.error || `HTTP ${response.status}`);
    }

    return await response.json();
  },

  /**
   * 메시지 기반 행동 감지 및 후보 업데이트
   * POST /api/engine/action
   */
  async sendAction(roomId, message) {
    const token = await getAuthToken();

    // GPS 좌표 가져오기 (OS 캐시 사용, 최대 1분 이내, 타임아웃 2초)
    // 실패해도 무시하고 서버가 DG Engine GPS 또는 집 주소로 폴백
    let userLat = null;
    let userLng = null;
    try {
      await new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => { userLat = pos.coords.latitude; userLng = pos.coords.longitude; resolve(); },
          () => resolve(),
          { maximumAge: 60000, timeout: 2000 }
        );
      });
    } catch (_) {}

    const response = await fetch(`${API_BASE_URL}/api/engine/action`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ roomId, message, userLat, userLng }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errData.error || `HTTP ${response.status}`);
    }

    return await response.json();
  },

  /**
   * Top 후보 조회
   * GET /api/engine/candidates/:roomId
   */
  async getCandidates(roomId) {
    const token = await getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/engine/candidates/${roomId}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errData.error || `HTTP ${response.status}`);
    }

    return await response.json();
  },

  /**
   * 세션 상태 요약 조회
   * GET /api/engine/state/:roomId
   */
  async getSessionState(roomId) {
    const token = await getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/engine/state/${roomId}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errData.error || `HTTP ${response.status}`);
    }

    return await response.json();
  },

  /**
   * 엔진 세션 종료
   * DELETE /api/engine/session/:roomId
   */
  async destroySession(roomId) {
    const token = await getAuthToken();
    const response = await fetch(`${API_BASE_URL}/api/engine/session/${roomId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` },
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errData.error || `HTTP ${response.status}`);
    }

    return await response.json();
  },
};
